export default ".button_message {\n  cursor: pointer;\n}"